(function () {

  // Ajax routes need the market root, or Shopify answers in the default market. routes.root ends in '/'.
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  }
  const root = document.querySelector('[data-main-product]');
  if (!root) return;

  // ── Wishlist heart ──────────────────────────────────────────
  // The inline PDP heart routes through the shared card-wishlist binder (same as
  // the cards) → toggles add/remove via BroraWishlist (which also fires the Voyado
  // favourite notify) and stays in sync with changes elsewhere. The binder is a
  // deferred global later in <body>, so bind once it's available.
  const wishlistHeart = root.querySelector('[data-wishlist]');
  if (wishlistHeart) {
    const bindWishlistHeart = () => {
      if (window.BroraProductCardWishlist && window.BroraProductCardWishlist.bind) {
        window.BroraProductCardWishlist.bind(wishlistHeart);
      }
    };
    if (window.BroraProductCardWishlist) bindWishlistHeart();
    else document.addEventListener('DOMContentLoaded', bindWishlistHeart);
  }

  // ── Colour swatch hover ─────────────────────────────────────
  const colourSwatchesEl = root.querySelector('[data-colour-swatches]');
  const selectedColourDisplay = root.querySelector('[data-selected-colour]');
  if (colourSwatchesEl && selectedColourDisplay) {
    colourSwatchesEl.addEventListener('mouseover', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      selectedColourDisplay.textContent = swatch.dataset.swatchColour;
    });
    colourSwatchesEl.addEventListener('mouseout', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      const selected = colourSwatchesEl.querySelector('[data-swatch][aria-current="true"]');
      if (selected) selectedColourDisplay.textContent = selected.dataset.swatchColour;
    });
    colourSwatchesEl.addEventListener('focusin', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      selectedColourDisplay.textContent = swatch.dataset.swatchColour;
    });
    colourSwatchesEl.addEventListener('focusout', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      const selected = colourSwatchesEl.querySelector('[data-swatch][aria-current="true"]');
      if (selected) selectedColourDisplay.textContent = selected.dataset.swatchColour;
    });
    colourSwatchesEl.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      const url = swatch.dataset.swatchUrl;
      // Sibling colourways are separate products at separate URLs (colour_variants, TD-73).
      // Navigate to the sibling product — do not attempt in-page variant swap.
      if (url) {
        window.location.href = url;
        return;
      }
    });
  }

  // ── Notify Me ───────────────────────────────────────────────
  const ctaArea = root.querySelector('[data-cta-area]');
  const notifyForm = root.querySelector('[data-notify-form]');
  const notifyEmail = root.querySelector('[data-notify-email]');
  const notifySubmit = root.querySelector('[data-notify-submit]');
  const notifySuccess = root.querySelector('[data-notify-success]');

  // Selected (OOS) variant id, resolved from the parsed variant map in
  // initVariantSelector — never the hidden cart input (hidden when OOS).
  let selectedVariantId = null;

  function updateNotifyState(variantAvailable) {
    if (!ctaArea || !notifyForm) return;
    if (variantAvailable) {
      ctaArea.classList.remove('hidden');
      notifyForm.classList.add('hidden');
      if (notifyEmail) notifyEmail.value = '';
      if (notifySubmit) {
        notifySubmit.setAttribute('aria-disabled', 'true');
        notifySubmit.classList.add('hidden');
      }
      if (notifySuccess) {
        notifySuccess.classList.add('hidden');
        notifySuccess.classList.remove('flex');
      }
    } else {
      ctaArea.classList.add('hidden');
      notifyForm.classList.remove('hidden');
      if (notifySubmit) notifySubmit.classList.remove('hidden');
    }
  }

  if (notifyEmail && notifySubmit) {
    notifyEmail.addEventListener('input', () => {
      if (notifyEmail.value.trim() !== '') {
        notifySubmit.removeAttribute('aria-disabled');
      } else {
        notifySubmit.setAttribute('aria-disabled', 'true');
      }
    });
    const errorEl = root.querySelector('[data-notify-error]');
    const errorCopy = notifyForm.dataset.notifyErrorText || 'Something went wrong. Please try again.';
    const timeoutCopy = notifyForm.dataset.notifyTimeoutText || 'That took too long. Please try again.';

    function showNotifyError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
    }

    notifySubmit.addEventListener('click', async () => {
      if (notifySubmit.getAttribute('aria-disabled') === 'true') return;
      const email = notifyEmail.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showNotifyError(errorCopy);
        return;
      }

      const productId = notifyForm.dataset.notifyProductId;
      const shop = notifyForm.dataset.notifyShop;
      const variantId = selectedVariantId;

      // Guard: no resolved variant → show a visible error rather than
      // POSTing variant_no="null" and silently failing (code-review N-1).
      if (!variantId) {
        showNotifyError(errorCopy);
        return;
      }

      notifySubmit.setAttribute('aria-disabled', 'true');
      notifySubmit.classList.add('hidden');
      if (errorEl) {
        errorEl.classList.add('hidden');
        errorEl.textContent = '';
      }

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);

      try {
        let ok = false;
        if (typeof window.BIS?.create === 'function') {
          const resp = await window.BIS.create(email, Number(variantId), Number(productId));
          ok = resp && resp.status === 'OK';
        } else {
          const qs = new URLSearchParams();
          qs.set('shop', shop);
          qs.set('notification[email]', email);
          qs.set('notification[product_no]', productId);
          qs.set('variant[variant_no]', variantId);
          qs.set('notification[quantity_required]', '1');
          qs.set('notification[accepts_marketing]', 'false');
          const url = 'https://app.backinstock.org/stock_notification/create.json?' + qs.toString();
          const res = await fetch(url, { signal: controller.signal });
          if (!res.ok) throw new Error('http');
          const body = await res.json().catch(() => ({}));
          ok = body && body.status === 'OK';
        }

        if (ok) {
          notifyForm.classList.add('hidden');
          if (notifySuccess) {
            notifySuccess.classList.remove('hidden');
            notifySuccess.classList.add('flex');
          }
        } else {
          showNotifyError(errorCopy);
        }
      } catch (err) {
        showNotifyError(err.name === 'AbortError' ? timeoutCopy : errorCopy);
      } finally {
        clearTimeout(timer);
        notifySubmit.removeAttribute('aria-disabled');
      }
    });
  }

  // ── Shop the Look scroll ────────────────────────────────────
  // Two anchors render (mobile gallery + desktop grid) — bind both.
  root.querySelectorAll('[data-stl-anchor]').forEach((stlBtn) => {
    stlBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('shop-the-look');
      if (!target) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // ── Variant selector ───────────────────────────────────────
  function initVariantSelector() {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const variants = data.variants || [];
    const colourPos = Number(data.colourOptionPosition) || 0;
    const sizePos = Number(data.sizeOptionPosition) || 0;

    const colourKey = (v) => (colourPos > 0 ? v.options[colourPos - 1] : '__none__');
    const sizeKey = (v) => (sizePos > 0 ? v.options[sizePos - 1] : '__none__');

    const variantMap = new Map();
    variants.forEach((v) => {
      const colour = colourKey(v);
      if (!variantMap.has(colour)) variantMap.set(colour, new Map());
      variantMap.get(colour).set(sizeKey(v), v);
    });

    const selectedColourEl = root.querySelector('[data-selected-colour]');
    let selectedColour = selectedColourEl ? selectedColourEl.textContent.trim() : '';

    // Low-stock ("Only X left") sync. Mirrors the server condition in
    // main-product.liquid (available + tracked inventory + 0 < qty <= threshold).
    // Threshold + resolved i18n template come from the DOM — no hardcoded number/string.
    const lowStockThreshold = Number(data.lowStockThreshold) || 0;
    // `product.variants | json` does NOT serialise inventory_quantity — read it from the
    // explicit Liquid-loop map in the JSON blob (keyed by variant id, string keys).
    const inventoryMap = data.inventory || {};
    const lowStockEl = root.querySelector('[data-low-stock]');
    const lowStockTemplate = lowStockEl ? lowStockEl.dataset.lowStockTemplate || '' : '';
    function updateLowStock(variant) {
      if (!lowStockEl) return;
      const rawQty = variant ? inventoryMap[String(variant.id)] : undefined;
      const qty = typeof rawQty === 'number' ? rawQty : null;
      const eligible =
        variant &&
        variant.available &&
        variant.inventory_management &&
        qty !== null &&
        qty > 0 &&
        qty <= lowStockThreshold;
      if (eligible) {
        lowStockEl.textContent = lowStockTemplate.replace('%%QTY%%', qty);
        lowStockEl.classList.remove('hidden');
      } else {
        lowStockEl.classList.add('hidden');
        lowStockEl.textContent = '';
      }
    }

    // Variant-level pre-order sync. STATE mirrors the server is_preorder in main-product.liquid: a variant
    // is pre-order when it carries a selling-plan allocation (Notify Me / ReStock) AND is continue-selling +
    // out of stock. The ship DATE is decoupled — the restock map (variant id → formatted restock date) is
    // OPTIONAL display text only, shown only when a pre-order variant also has a date. Swaps the CTA label
    // and reveals the ship-date line, or reverts to the default "Add to Bag".
    const preorderMap = data.preorder || {};
    // Both the buy area and the sticky bar carry the ship-date line, so every instance is kept in sync.
    const preorderShipEls = root.querySelectorAll('[data-preorder-ship]');
    const preorderShipTemplate = preorderShipEls[0] ? preorderShipEls[0].dataset.preorderShipTemplate || '' : '';

    // A pre-order variant carries a Shopify selling plan (created by the pre-order app) in its
    // selling_plan_allocations. Enabling + submitting name="selling_plan" makes the add-to-cart a
    // deferred purchase option, so the checkout treats it as a real pre-order (the plan's own fulfilment
    // date applies). Keyed on the explicit sellingPlans map (variant id → selling_plan_id) since
    // selling_plan_allocations isn't in `product.variants | json`. Disabled when the variant has no plan →
    // FormData omits it (normal add). Toggled alongside the pre-order display, per selected variant.
    const sellingPlanMap = data.sellingPlans || {};
    const sellingPlanInput = root.querySelector('[data-selling-plan]');
    function updateSellingPlan(variant) {
      if (!sellingPlanInput) return;
      const planId = variant ? sellingPlanMap[String(variant.id)] : undefined;
      if (planId) {
        sellingPlanInput.value = planId;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
      }
    }

    function updatePreorder(variant) {
      // STATE ← selling-plan presence (mirrors the server is_preorder). DATE ← restock map, optional text only.
      const isPre = !!(variant && sellingPlanMap[String(variant.id)]);
      const shipDate = variant ? preorderMap[String(variant.id)] : undefined;
      // Swap the label on BOTH the main CTA and the sticky-atb button (each carries data-atb-label-default
      // / -preorder). Skip a button still in its disabled "Choose Size" state — activateAtbButtons owns
      // that until a size is picked, and it runs before this in selectVariantFromRadio.
      root.querySelectorAll('[data-atb-label-default]').forEach((btn) => {
        if (btn.hasAttribute('data-atb-needs-size')) return;
        const labelEl = btn.querySelector('[data-atb-label]');
        const label = isPre ? btn.dataset.atbLabelPreorder : btn.dataset.atbLabelDefault;
        if (labelEl && label) labelEl.textContent = label;
      });
      preorderShipEls.forEach((el) => {
        if (isPre && shipDate) {
          el.textContent = preorderShipTemplate.replace('%%DATE%%', shipDate);
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
          el.textContent = '';
        }
      });
      if (ctaArea) {
        ctaArea.classList.toggle('gap-lg', isPre);
        ctaArea.classList.toggle('gap-sm', !isPre);
      }
      updateSellingPlan(variant);
    }

    function updateSizeAvailability(colour) {
      const colourVariants = variantMap.get(colour) ?? variantMap.get('__none__') ?? new Map();
      root.querySelectorAll('[data-size-options] label.action-size').forEach((label) => {
        const radio = label.querySelector('input[type="radio"]');
        if (!radio) return;
        const variant = colourVariants.get(radio.value);
        const unavailable = !variant || !variant.available;
        if (unavailable) {
          label.setAttribute('aria-disabled', 'true');
          radio.disabled = true;
        } else {
          label.removeAttribute('aria-disabled');
          radio.disabled = false;
        }
      });
    }

    // First size selection → flip both ATB buttons (main + sticky) out of the disabled
    // "Choose Size" state to their active "Add to Bag"/"Pre-order now" label. One-way:
    // a size can never be unselected, so this never runs in reverse.
    function activateAtbButtons() {
      root.querySelectorAll('[data-atb-needs-size]').forEach((btn) => {
        const labelEl = btn.querySelector('[data-atb-label]');
        if (labelEl && btn.dataset.atbReadyLabel) labelEl.textContent = btn.dataset.atbReadyLabel;
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('action-pill--choose-size');
        btn.removeAttribute('data-atb-needs-size');
      });
    }

    // Focus the notify email, but not if it already has focus — avoids replaying the label's focus
    // animation when switching between OOS sizes. The notify form replaces the CTA in place, so it's
    // already in view; the default focus scroll (no smooth) reveals it only if it isn't.
    function focusNotifyEmail() {
      if (notifyEmail && document.activeElement !== notifyEmail) notifyEmail.focus();
    }

    // Bring the buy area to the top of the viewport, then focus the notify email (no second scroll).
    function scrollToNotify() {
      const buyArea = root.querySelector('[data-pdp-sticky]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (buyArea) buyArea.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      if (notifyEmail) notifyEmail.focus({ preventScroll: true });
    }

    // Resolve + select the variant for a size radio: sync the hidden cart input, the notify-me variant,
    // and the URL, then flip the CTA/notify state. focusNotify pulls focus to the notify email — used
    // when picking an out-of-stock size (direct click, or bridged from the gift drawer) so the shopper
    // lands on the notify field.
    function selectVariantFromRadio(radio, focusNotify) {
      if (!radio) return;
      const colourVariants = variantMap.get(selectedColour) ?? variantMap.get('__none__');
      const variant = colourVariants?.get(radio.value);
      if (!variant) return;

      const variantInput = root.querySelector('[data-variant-id]');
      if (variantInput) variantInput.value = variant.id;
      selectedVariantId = variant.id;
      activateAtbButtons();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());

      updateNotifyState(variant.available);
      updateLowStock(variant);
      updatePreorder(variant);

      if (focusNotify && !variant.available) scrollToNotify();
    }

    // Minimal PDP API for other surfaces (mini-bag pre-order routing, gift drawer): select a variant on
    // the already-open PDP WITHOUT navigating. Resolve the variant's size and drive the same radio path a
    // size click uses. Pre-order variants are continue-selling, so their size label is enabled/selectable.
    // Returns true when the variant was resolved + selected (or the product has no size picker), else false.
    window.broraProduct = {
      selectVariant: function (variantId, focusNotify) {
        const target = variants.find((v) => String(v.id) === String(variantId));
        if (!target) return false;
        const sizeOptionsEl = root.querySelector('[data-size-options]');
        if (!sizeOptionsEl) {
          // default-variant product: nothing to pick; still route to the notify form if it's out of stock
          if (focusNotify && !target.available) scrollToNotify();
          return true;
        }
        const radio = sizeOptionsEl.querySelector('input[type="radio"][value="' + CSS.escape(sizeKey(target)) + '"]');
        if (!radio) return false;
        radio.checked = true;
        selectVariantFromRadio(radio, !!focusNotify);
        return true;
      },
      scrollToNotify: scrollToNotify,
    };

    const sizeOptions = root.querySelector('[data-size-options]');
    sizeOptions?.addEventListener('change', (e) => {
      selectVariantFromRadio(e.target.closest('input[type="radio"]'), false);
    });

    // Out-of-stock sizes keep their radio disabled (not addable), so they never fire `change`. Handle
    // their click here → mark it checked (a disabled radio can't be user-checked, but JS can set the
    // state, so `:has(:checked)` gives the "selected OOS" inverted pill per orch_PDP_HEADER_V2), select
    // the variant, reveal the notify form and focus the email. Single source of truth reused by the gift
    // drawer's OOS pills (which click the matching PDP label).
    sizeOptions?.addEventListener('click', (e) => {
      const label = e.target.closest('label.action-size[aria-disabled="true"]');
      if (!label) return;
      const radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      selectVariantFromRadio(radio, true);
    });

    updateSizeAvailability(selectedColour);
    const initChecked = root.querySelector('[data-size-options] input[type="radio"]:checked');
    if (initChecked) {
      const initVariants = variantMap.get(selectedColour) ?? variantMap.get('__none__');
      const initVariant = initVariants?.get(initChecked.value);
      if (initVariant) selectedVariantId = initVariant.id;
      updateNotifyState(initVariant ? initVariant.available : false);
      updateLowStock(initVariant);
      updatePreorder(initVariant);
      // Page loaded on an out-of-stock variant → focus the notify email too, matching an OOS-size click.
      if (initVariant && !initVariant.available) focusNotifyEmail();
    } else if (!sizeOptions) {
      // Default-variant (no sizes): the sole variant is the selection, since no size radio will ever
      // resolve one. Loaded out of stock → focus the notify email, matching the init above.
      const onlyVariant = (variantMap.get(selectedColour) ?? variantMap.get('__none__'))?.get('__none__');
      if (onlyVariant) selectedVariantId = onlyVariant.id;
      updateLowStock(onlyVariant);
      updatePreorder(onlyVariant);
      if (onlyVariant && !onlyVariant.available) focusNotifyEmail();
    }
  }

  // ── Add to Cart ─────────────────────────────────────────────
  function initAddToCart() {
    const form = root.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const errorEl = form.querySelector('[data-cart-error]');
      const variantId = form.querySelector('[data-variant-id]')?.value;
      if (!variantId) return;
      // "Choose Size" state — the hidden input still holds first_available, which the
      // shopper never chose, so never add. Take them to the size picker instead.
      if (btn && btn.hasAttribute('data-atb-needs-size')) {
        const sizeOptions = root.querySelector('[data-size-options]');
        if (sizeOptions) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          sizeOptions.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }

      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
      if (errorEl) errorEl.classList.add('hidden');

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);

      try {
        // Submit the whole product form (FormData), not a hardcoded { id, quantity }: the form may
        // carry line-item properties[...] and additional items[...] injected by apps (e.g. the
        // Wrapped gift-wrap app adds the gift product + gift message this way). A minimal JSON body
        // would silently drop them, so the gift/message never reaches the cart.
        const res = await fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
          signal: controller.signal,
        });

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.description || 'Could not add to bag');
        }

        // Pre-order size swap — if this add fulfils a mini-bag "change size" to this variant, remove the
        // original line so it's a swap, not a duplicate. Single-use (cleared on any PDP add); 30-min expiry.
        try {
          const swap = JSON.parse(sessionStorage.getItem('brora.preorderSwap') || 'null');
          sessionStorage.removeItem('brora.preorderSwap');
          if (
            swap &&
            swap.removeKey &&
            swap.ts &&
            Date.now() - swap.ts < 1800000 &&
            String(swap.variantId) === String(variantId)
          ) {
            await fetch(shopRoot() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: swap.removeKey, quantity: 0 }),
            });
          }
        } catch (e) {
          /* fail-safe: the add succeeded; leave the original line as-is */
        }

        // Pass the added line item + the displayed compare-at price so the notification renders the price and
        // compare instantly, matching the PLP add (add-to-bag.js). The AJAX cart omits compare_at_price, so the
        // compare comes from the DOM (innerHTML carries the AED glyph markup).
        var addedResp = await res.json().catch(function () { return null; });
        var addedItem = addedResp && (addedResp.items ? addedResp.items[0] : addedResp);
        var pdpCompareEl = document.querySelector('[data-main-product] [data-pdp-compare]');
        var pdpCompare = pdpCompareEl ? pdpCompareEl.innerHTML.trim() : null;
        form.dispatchEvent(new CustomEvent('cart:added', {
          bubbles: true,
          detail: { item: addedItem, compareText: pdpCompare, variantId: String(variantId) },
        }));
        // Notify Elevate of the add (Voyado data/ticket logic lives in voyado-product-page.js).
        if (window.VoyadoProductPage) window.VoyadoProductPage.notifyAddToCart();
      } catch (err) {
        if (errorEl) {
          errorEl.textContent =
            err.name === 'AbortError'
              ? 'Request timed out. Please try again.'
              : err.message || 'Something went wrong. Please try again.';
          errorEl.classList.remove('hidden');
        }
      } finally {
        clearTimeout(timeout);
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        }
      }
    });
  }

  // ── Denomination picker ─────────────────────────────────────
  function initDenominationPicker() {
    const denomWrapper = root.querySelector('[data-denomination-options]');
    if (!denomWrapper) return;

    denomWrapper.addEventListener('change', (e) => {
      const label = e.target.closest('label');
      if (!label) return;
      const variantId = label.dataset.variantId;
      if (!variantId) return;
      const variantInput = root.querySelector('[data-variant-id]');
      if (variantInput) variantInput.value = variantId;
    });
  }

  initVariantSelector();
  initAddToCart();
  initDenominationPicker();

  // ── Wishlist heart ──────────────────────────────────────────
  // product-card-wishlist.js is a deferred script in theme.liquid (after
  // content_for_layout), so window.BroraProductCardWishlist is not yet
  // defined when this deferred script runs. DOMContentLoaded fires only
  // after all deferred scripts complete, so it is safe to call bind() there.
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      const wishlistBtn = root.querySelector('[data-wishlist-add]');
      if (wishlistBtn && window.BroraProductCardWishlist?.bind) {
        window.BroraProductCardWishlist.bind(wishlistBtn);
      }
    },
    { once: true },
  );
})();
